import { motion } from "framer-motion";
import { Lock, MapPin, ClipboardList, Handshake } from "lucide-react";

const reasons = [
  {
    icon: Lock,
    title: "Discrétion & confidentialité absolue",
    desc: "Vos informations et votre propriété sont traités avec la plus stricte confidentialité.",
  },
  {
    icon: MapPin,
    title: "Équipe 100% locale, ancrée à Tahiti",
    desc: "Une connaissance intime du territoire et de ses spécificités insulaires.",
  },
  {
    icon: ClipboardList,
    title: "Rapports réguliers & transparence totale",
    desc: "Des comptes rendus détaillés pour un suivi serein depuis n'importe où dans le monde.",
  },
  {
    icon: Handshake,
    title: "Un seul interlocuteur dédié",
    desc: "Un référent unique pour une relation de confiance personnalisée et efficace.",
  },
];

export default function WhyUs() {
  return (
    <section id="pourquoi" data-testid="why-us-section" className="py-24 md:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-6 mb-4">
            <div className="h-[1px] w-16 bg-[#b39a73]" />
            <h2
              className="text-3xl md:text-4xl text-[#2E3A34] tracking-[0.05em]"
              style={{ fontFamily: "'Cinzel', serif" }}
              data-testid="why-us-title"
            >
              Pourquoi nous choisir
            </h2>
            <div className="h-[1px] w-16 bg-[#b39a73]" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}
                className="text-center group"
                data-testid={`why-us-card-${index}`}
              >
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full border border-[#b39a73]/30 mb-6 group-hover:border-[#b39a73] transition-colors duration-300">
                  <Icon className="h-7 w-7 text-[#b39a73]" strokeWidth={1.5} />
                </div>
                <h3
                  className="text-lg text-[#2E3A34] mb-3 tracking-[0.02em]"
                  style={{ fontFamily: "'Cinzel', serif", fontSize: "1rem" }}
                >
                  {reason.title}
                </h3>
                <p
                  className="text-[#4E4A45] text-base leading-relaxed"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {reason.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
